/* eslint-disable @typescript-eslint/naming-convention */
import { TransferStatusKeyEnum } from './constant';

export type TransferStatusKey = `${TransferStatusKeyEnum}`;

export type TransferStatus =
  | 'CREATED'
  | 'APPROVED'
  | 'REVISE_NEEDED'
  | 'REJECTED'
  | 'PARTIAL'
  | 'COMPLETED';

export const ACTIVITY_STATUS = {
  CREATED: 'Created the Transfer Request|Created the Advanced Transfer Request',
  REJECTED: 'Rejected the Transfer Request',
  REJECTED_WITH_REVISION: 'Rejected the Transfer Request with Revision',
  UPDATED: 'Updated the Transfer Request',
  APPROVED: 'Approved the Transfer Request',
  PARTIALLY_SHIPPED: 'Partially Shipped the Transfer Request',
  PARTIALLY_FULFILLED: 'Partially Fulfilled the Transfer Request',
  FULLY_SHIPPED: 'Fully Shipped The Transfer Request',
  FULLY_FULFILLED: 'Fulfilled and Completed All of the Shipments',
  SHIPMENT_STOPPED: 'Stopped the Shipment and Closed the Transfer Request',
  DELETED: 'Deleted the Transfer Request',
  NON_BLOCKING_REJECTED: 'There is Problem in the System',
  BLOCKING_REJECTED: '-',
} as const;

export const NOTE_TITLE = {
  REJECTED_WITH_REVISION: 'Revision Note',
  REJECTED: 'Rejection Note',
  PARTIALLY_SHIPPED: 'Partial Shipment Note',
  PARTIALLY_FULFILLED: 'Partial Fulfillment Note',
} as const;

export type ActivityStatusKey = keyof typeof ACTIVITY_STATUS;
export type ActivityStatus = typeof ACTIVITY_STATUS[ActivityStatusKey];

export type BaseTransferAPI = {
  id: number;
  from_outlet_id: number;
  to_outlet_id: number;
  status: TransferStatus;
  created_at: string;
  short_order_number: string;
};

export type BaseTransfer = BaseTransferAPI & {
  from_outlet_name: string;
  to_outlet_name: string;
  status_key: TransferStatusKey;
  fulfilled_percentage: string;
  shipped_percentage: string;
};

export type BaseItem = {
  requested_quantity: number;
  fulfilled_quantity: number;
  unfulfilled_quantity: number;
  shipped_quantity: number;
  not_shipped_quantity: number;
};

export type ItemVariant = {
  id: number;
  name: string;
  sku: string;
  price: number;
  in_stock: number;
  stock_alert: number;
  cogs: number;
  track_cogs: boolean;
  has_cogs: boolean;
};

export type Item = BaseItem & {
  id: string;
  item_id: number;
  item_name: string;
  item_variant_id: number;
  item_variant_name: string;
  cogs?: number;
  in_stock?: number;
  item_variants?: ItemVariant[];
  is_multi_variant?: boolean;
};

export type Ingredient = BaseItem & {
  ingredient_id: number;
  ingredient_name: string;
  unit_id: number;
  unit_name: string;
  in_stock?: number;
  type?: string | null;
};

export type ItemTransferAPI = BaseTransferAPI & {
  items: Item[];
};

export type IngredientTransferAPI = BaseTransferAPI & {
  ingredients: Ingredient[];
};

export type ItemTransfer<T> = BaseTransfer & {
  items: T[];
};

export type TransferAPI = ItemTransferAPI | IngredientTransferAPI;

export type Transfer = ItemTransfer<Item> | ItemTransfer<Ingredient>;

export type FulFillment = {
  fulfilled_quantity?: number;
  unfulfilled_quantity?: number;
  shipped_quantity?: number;
  not_shipped_quantity?: number;
};

export type BaseActivity = {
  id: string;
  shipment_id: string;
  status: ActivityStatus;
  user_id: number;
  username: string;
  created_at: string;
};

export type AdditionalActivityAPI = {
  note: string;
  reason: string;
  items?: FulFillment[];
  ingredients?: FulFillment[];
  shipment_id?: string;
};

export type ActivityAPI = BaseActivity & {
  additional: AdditionalActivityAPI;
};

export type AdditionalActivity = {
  note: string;
  reason: string;
  fulfillment?: FulFillment[];
  shipment_id?: string;
};

export type Activity = BaseActivity & {
  status_key: ActivityStatusKey;
  additional?: AdditionalActivity;
};

export type TransferProcessItem = {
  no: number;
  shipmentDate: Date;
  fulfillmentDate?: Date;
  items: {
    requested: number;
    requested_edited: number;
    shipped?: number;
    isEdited: boolean;
    received?: number;
    not_received?: number;
  }[];
};
